<script setup>
/*==================================================================*/
/*================== VUE IMPORTS ===================================*/
/*==================================================================*/

import { ref, defineProps, defineExpose } from 'vue';

/*==================================================================*/
/*================== IMPORTS DE COMPONENTES ========================*/
/*==================================================================*/

import ModalConfirmacao from '@/components/v2/modais/ModalConfirmacao/ModalConfirmacao.vue';

/*==================================================================*/
/*================== IMPORTS DE UTILS ==============================*/
/*==================================================================*/

import Text from '@/utils/Text.js';

/*==================================================================*/
/*================== PROPS =========================================*/
/*==================================================================*/

const props = defineProps({
    disabled: {
        type: Boolean,
        default: false
    },
    confirmar: {
        type: Function,
        required: true
    }
});

/*==================================================================*/
/*================== JUSTIFICATIVA =================================*/
/*==================================================================*/

const justificativa = ref('');

const justificativaRegras = [
    (valor) => {

        if(Text.equalTo(valor, 0)){
            return true;
        }

        if(Text.lessThanOrEqualTo(valor, 140)){
            return true;
        }

        return 'Justificativa deve ter menos de 140 caracteres.';

    }
];

/*==================================================================*/
/*================== MODAL CONFIRMACAO REF =========================*/
/*==================================================================*/

const modalConfirmacaoRef = ref(null);

/*==================================================================*/
/*================== ABRIR / FECHAR MODAL ===========================*/
/*==================================================================*/

const abrirModal = async () => {

    justificativa.value = '';

    await modalConfirmacaoRef.value?.abrirModal();

};

const fecharModal = async () => {

    await modalConfirmacaoRef.value?.fecharModal();

};

/*==================================================================*/
/*================== AO CONFIRMAR ==================================*/
/*==================================================================*/

const aoConfirmar = async () => {

    if(Text.greatherOrEqualTo(justificativa.value, 140)){
        return;
    }

    await props.confirmar(justificativa.value);

    justificativa.value = '';

    await fecharModal();

};

/*==================================================================*/
/*================== EXPOSE ========================================*/
/*==================================================================*/

defineExpose({ abrirModal, fecharModal });

</script>

<template>

    <ModalConfirmacao
        ref="modalConfirmacaoRef"
        max-width="600"
        :disabled="props.disabled"
        :confirmar="aoConfirmar"
    >

        <template #header>
            Justifique o retorno das Requisições de Compra:
        </template>

        <template #body>

            <v-textarea
                v-model="justificativa"
                outlined
                clearable
                no-resize
                label="Justificativa"
                :rules="justificativaRegras"
                :disabled="props.disabled"
            ></v-textarea>

        </template>

    </ModalConfirmacao>

</template>
